// Remove overlay
// ----------

// console.log(show_load_overlay);
// console.log(overlay_fade_time);

if (show_load_overlay) {
  $(window).on("load", function () {
    if (show_load_overlay) {
      $(".site-overlay").addClass("remove-overlay");
      setTimeout(function () {
        $(".site-overlay").remove();
      }, overlay_fade_time);
      setTimeout(function () {
        $("body").removeClass("noscrollbar");
      }, overlay_fade_time);
    }
  });
} else {
  $(document).ready(function () {
    $(".site-overlay").remove();
    $("body").removeClass("noscrollbar");
  });
}
